import { render, staticRenderFns } from "./delivery-contract-depth.vue?vue&type=template&id=281ae1d7"
import script from "./delivery-contract-depth.vue?vue&type=script&lang=js"
export * from "./delivery-contract-depth.vue?vue&type=script&lang=js"
import style0 from "./delivery-contract-depth.vue?vue&type=style&index=0&id=281ae1d7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports